
// language
import { injectIntl, IntlShape } from 'react-intl';

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SegmentedBar from 'components/SegmentBar';


type Props = {
    intl: IntlShape,
    type?: string,
    warningTime?: number,
}

const Legend = ( { intl, type, warningTime }: Props ) => {

    return (
        <MDBox
            sx={{
                display: "flex", flexDirection: "row",
                gap: "1rem",
            }}
        >
            <MDBox
                sx={{
                    display: "flex", flexDirection: "column",
                    paddingTop: "0.9rem", paddingBottom: "0.9rem",
                    width: "-moz-available",
                }}
                >
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row",
                        gap: "0.5rem", paddingBottom: "0.5rem",
                    }}
                >
                    <MDBox
                    sx={{ 
                        width: '1.25rem', height: '1.25rem', 
                        backgroundColor: '#309B0A', borderRadius: "0.19rem"
                    }}
                    />
                    <MDTypography
                    sx={{
                        fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                    }}
                    >
                    {intl.formatMessage({id:'containerInfo.closedContainer'})}
                    </MDTypography>
                </MDBox>
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row",
                        gap: "0.5rem", paddingBottom: "0.5rem",
                    }}
                >
                    <MDBox
                    sx={{ 
                        width: '1.25rem', height: '1.25rem', 
                        backgroundColor: '#F5A524', borderRadius: "0.19rem"
                    }}
                    />
                    <MDTypography
                    sx={{
                        fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                    }}
                    >
                        {intl.formatMessage({id:'containerInfo.openContainer'})}
                    </MDTypography>
                </MDBox>
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row", gap: "0.5rem",
                        paddingBottom: "0.5rem",
                    }}
                >
                    <MDBox
                        sx={{ 
                            width: '1.25rem', height: '1.25rem', 
                            backgroundColor: '#DD2626', borderRadius: "0.19rem"
                        }}
                    />
                    <MDTypography
                        sx={{
                            fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                        }}
                    >
                        {intl.formatMessage(
                            {id:'containerInfo.openContainerWarning'},
                            {warningTime}
                        )}
                    </MDTypography>
                </MDBox>
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row",
                        gap: "0.5rem",
                    }}
                >
                    <MDBox
                    sx={{ 
                        width: '1.25rem', height: '1.25rem', 
                        backgroundColor: '#7B809A', borderRadius: "0.19rem"
                    }}
                    />
                    <MDTypography
                    sx={{
                        fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                    }}
                    >
                        {intl.formatMessage({id:'containerInfo.unknown'})}
                    </MDTypography>
                </MDBox>
            </MDBox>

            {/* reservation */}
            { type === 'containerDetail' && (
                <MDBox
                    sx={{
                        width: "22rem",
                        display: "flex", flexDirection: "row",
                    }}
                >
                    <MDBox
                        sx={{
                            width: "5rem",
                            display: "flex", flexDirection: "row",
                            marginRight: "0.5rem",
                        }}
                    >
                        <MDBox
                            sx={{
                                display: "flex", flexDirection: "column",
                                justifyContent: "center", width: "100%",
                            }}
                        >
                            <MDBox
                                sx={{
                                    display: "flex", flexDirection: "column",
                                    alignItems: "center", border: "2px solid #ccc",
                                    borderRadius: "8px", p: "0.15rem",
                                    width: "100%", background: "#fff",
                                }}
                            >
                                <MDBox 
                                    sx={{
                                        display: "flex", flexDirection: "column",
                                        alignItems: "center", marginBottom: "0.1rem",
                                        width: "100%", background: "#F0EDE8",
                                        borderRadius: "5px", paddingBottom: "0.15rem",
                                    }}
                                >
                                    <MDTypography
                                        sx={{
                                            fontSize: "1rem", fontWeight: "400",
                                        }}
                                    >
                                        {`3/8`}
                                    </MDTypography>
                                    <SegmentedBar total={8} filled={3} />
                                </MDBox>
                                <MDBox 
                                    sx={{
                                        display: "flex", flexDirection: "column",
                                        alignItems: "center", width: "100%",
                                        background: "#F0EDE8", borderRadius: "5px",
                                    }}
                                >
                                    <MDTypography
                                        sx={{
                                            fontSize: "1rem", fontWeight: "400",
                                        }}
                                    >
                                    {`5/8`}
                                    </MDTypography>
                                    <SegmentedBar total={8} filled={5} />
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </MDBox>

                    <MDBox
                        sx={{
                            display: "flex", flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <MDBox
                            sx={{
                                width: "9rem", textAlign: "center",
                            }}
                        >
                            <MDTypography
                                sx={{
                                    fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                                }}
                            >
                                {intl.formatMessage({id:'containerInfo.reservationLegendFirstRow'})}
                            </MDTypography>
                            <MDTypography
                                sx={{
                                    fontSize: "0.75rem", fontWeight: "700", color: "#807E7B",
                                    marginTop: "-0.2rem",
                                }}
                            >
                                {intl.formatMessage({id:'containerInfo.reservationLegendReservationCapacity'})}
                            </MDTypography>
                        </MDBox>
                        <MDBox
                            sx={{
                                width: "9rem",
                                textAlign: "center",
                            }}
                        >
                            <MDTypography
                                sx={{
                                    fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                                }}
                            >
                                {intl.formatMessage({id:'containerInfo.reservationLegendSecondRow'})}
                            </MDTypography>
                            <MDTypography
                                sx={{
                                    fontSize: "0.75rem", fontWeight: "700", color: "#807E7B",
                                    marginTop: "-0.2rem",
                                }}
                            >
                                {intl.formatMessage({id:'containerInfo.reservationLegendReservationCapacity'})}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            )}
        </MDBox>

    )
}

export default injectIntl(Legend);